export default __webpack_public_path__ + "static/media/koodo-blue.bb2aa3e0.png";